'use-strict';

import angular from 'angular';

import './scss/_index.scss';
import config from './app.config';
import routing from './app.routes';
import upgradedRoutes from './app.upgraded.routes';

import components from './components/index.component';
import libraries from './libs/libs.module';
import shared from './shared/shared.index';
import uiComponents from './ui-components/ui-components.index';

const MODULE_NAME = 'autoboard';
const MODULE_DEPENDENCIES = [
  components,
  libraries,
  shared,
  uiComponents,
];

angular
  .module(MODULE_NAME, MODULE_DEPENDENCIES)
  // .factory('$location', downgradeInjectable($locationShim))
  .config(routing)
  .config(upgradedRoutes)
  .run(config);
